import {
  HStack,
  Box
} from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";

import { ReactComponent as ArrowRightSvg } from "../../assets/icons/arrow-right.svg";
import { routes } from "../../constants";
import { kebabCase } from "../../helpers/string";
import {
  ColumnLayout,
  columnSpacing
} from "../shared/ColumnLayout";
import { Text } from "../text";
import theme from "../theme";
import { topicPreviewContent } from "./topics";

export const SubRouteLinks: React.FC = () => {
  return (
    <ColumnLayout
      title="Reduce your carbon"
      py={columnSpacing}
      content={[
        (
          <>
            {Object.entries(topicPreviewContent).map(([ title, { text } ]) => (
              <HStack
                key={title}
                p={{
                  base: "1em 0",
                  md: theme.spacing[ 6 ]
                }}
                _first={{ paddingTop: 0 }}
                borderBottom={`1px solid ${theme.colors.gray[ 500 ]}`}
                _last={{ border: "none" }}
                spacing="1em"
              >
                <HStack
                  as={Link}
                  to={routes.reduceSection(kebabCase(title))}
                  flex="1"
                >
                  <Box flex="1">
                    <Text
                      fontWeight="medium"
                      color={theme.colors.gray[ 800 ]}
                      fontSize={{
                        base: theme.fontSizes.base,
                        md: theme.fontSizes.md
                      }}
                    >
                      {title}
                    </Text>

                    <Text
                      fontSize={theme.fontSizes.sm}
                      color={theme.colors.gray[ 500 ]}
                    >
                      {text}
                    </Text>
                  </Box>

                  <Box
                    w="20px"
                    h="20px"
                    color={theme.colors.green[ 300 ]}
                    alignSelf="flex-end"
                    ml="1rem"
                  >
                    <ArrowRightSvg fill="currentColor" />
                  </Box>
                </HStack>
              </HStack>
            ))}
          </>
        )
      ]}
    />
  );
};